module.exports = __webpack_public_path__ + "static/media/opposition-2.db57e778.png";